import { AREA, COLUMN, CUSTOM, DATA_WELL, FUNNEL, LINE } from 'reporting-data/constants/chartTypes';
import { AGGREGATION, PIPELINE, TIME_SERIES } from 'reporting-data/constants/configTypes';
import { CROSS_OBJECT } from 'reporting-data/constants/dataTypes';
import { getConfigType, getDataType } from 'reporting-data/report/configReportGetters';
import { isConfigReport, isRelationalReport } from 'reporting-data/tsTypes/reportTypes';
// @ts-expect-error Untyped import
import { isMismatchedDimensionDateFilterPropertyTimeSeries } from 'reporting-data/properties/isMismatchedDimensionDateFilterPropertyTimeSeries';
import { VisualTypes } from 'reporting-snowflake/relational/schema/visual-records';
import { createRelationalReportFromBaseReport, getReportVisualType } from 'reporting-snowflake/relational/utils/report-utils';
import getMeasureSizeRanges from '../../lib/report-utils/getMeasureSizeRanges';
export const getIsReportValidForDimensionEditorDropdown = ({
  report
}) => {
  if (isConfigReport(report)) {
    return [AGGREGATION, TIME_SERIES].includes(getConfigType(report)) && getMeasureSizeRanges(report).maxDimensions >= 1;
  } else if (isRelationalReport(report)) {
    const relationalReport = createRelationalReportFromBaseReport(report);
    const visualType = getReportVisualType(relationalReport);
    return !(visualType === VisualTypes.DONUT || visualType === VisualTypes.PIE || visualType === VisualTypes.TEXT || visualType === VisualTypes.GAUGE) && getMeasureSizeRanges(relationalReport).maxDimensions >= 1;
  }
  return false;
};
const isCrossObject = report => getDataType(report) === CROSS_OBJECT;
const canBeComparisonConfig = report => {
  const configType = report.getIn(['config', 'configType']);
  if (isCrossObject(report) || [FUNNEL, PIPELINE].includes(configType)) {
    return false;
  }
  const chartType = report.get('chartType');
  const dimensions = report.getIn(['config', 'dimensions']);
  const isMultiDimensional = dimensions && dimensions.size > 1;
  return [DATA_WELL, CUSTOM].includes(chartType) || chartType === COLUMN && !isMultiDimensional || [LINE, AREA].includes(chartType) && configType === TIME_SERIES && !isMultiDimensional;
};
export const isCompareValid = report => canBeComparisonConfig(report) && !isMismatchedDimensionDateFilterPropertyTimeSeries(report);
export const disableUISelectOptionForDimensionOrBreakdownDropdown = (options, valueToDisable) => {
  return options.map(group => {
    const updatedOptions = group.options.map(option => {
      if (option.value === valueToDisable) {
        return Object.assign({}, option, {
          disabled: true
        });
      }
      return option;
    });
    return Object.assign({}, group, {
      options: updatedOptions
    });
  });
};